<template>
  <div class="relative flex h-full w-full transform flex-col items-stretch overflow-y-auto bg-whitegray pt-8">
      <button class="outline-none absolute left-auto right-4 top-4 text-center text-sm text-black z-10" @click="emit('close')" type="button">
          <img src="~/assets/icon/icon-close-gray-black.svg" alt="" class="h-8 rounded-full bg-black opacity-20">
      </button>

    <MyLocationDialog
      :show="showMyLocationDialog"
      @close="closeMyLocationDialog"
      @location-changed="emit('backToCart')"
    />
    <div class="flex grow flex-col items-stretch px-4">
      <strong class="mb-4 text-2xl font-medium">Оформление заказа</strong>

      <div class="flex grow flex-col items-stretch gap-4 self-stretch">
        <div class="rounded-xl bg-current bg-gray p-1.5 text-sm">
          <div class="relative">
            <div
              class="absolute bottom-0 left-0 top-0 w-1/2 rounded-lg bg-white shadow-main transition-transform"
              :class="{
                'translate-x-0': receptionWay?.type === 'delivery',
                'translate-x-full': receptionWay?.type === 'restaurant',
              }"
            ></div>
            <button
              class="hover isolate h-10 w-1/2 rounded-lg"
              type="button"
              @click="showMyLocationDialog = true"
            >
              Доставка
            </button>
            <button
              class="isolate h-10 w-1/2 rounded-lg"
              type="button"
              @click="showMyLocationDialog = true"
            >
              Самовывоз
            </button>
          </div>
        </div>

        <div class="relative grow pt-4 pb-8">
          <Transition
            name="fade"
            mode="out-in"
          >
            <OrderDialogPaymentReceptionFormDelivery
              v-if="receptionWay?.type === 'delivery'"
              @location-changed="emit('backToCart')"
              @date-changed="dateChanged"
              @leave-under-door-changed="leaveUnderDoorChanged"
            />
            <OrderDialogPaymentReceptionFormRestaurant
              v-else-if="receptionWay?.type === 'restaurant'"
              @location-changed="emit('backToCart')"
              @date-changed="dateChanged"
            />
          </Transition>
        </div>
      </div>
    </div>

    <div class="bg-white px-4 py-8 shadow-main">
      <p class="text-lg">Доставка: {{props.basket?.delivery_price.toFixed(2)}}&nbsp;&#8381;</p>
      <p class="mt-3 mb-2 text-lg">Выберите способ оплаты (к оплате: {{paymentSum.toFixed(2)}}&nbsp;&#8381;)</p>

      <HeadlessRadioGroup v-model="selectedPayType" v-if="isRestaurantLoaded && isUserLoaded">
        <OrderDialogInputRadio
          value="cash"
          :label="'Наличными'+(!user.delivery_zone.available_payments.cash ? ' (временно недоступно для выбранного ресторана)' : '')"
          :disabled="!user.delivery_zone.available_payments.cash || isLeaveUnderDoor"
        >
          <IconBlackWallet />
        </OrderDialogInputRadio>
        <div
          class="mb-2 grid grid-cols-1 grid-rows-[0fr] overflow-hidden transition-[grid-template-rows]"
          :class="{
            'grid-rows-[1fr]': selectedPayType === 'cash',
          }"
        >
          <div class="min-h-0">
            <div class="ml-8 py-2">
              <p class="mb-2 text-sm text-black text-opacity-50">С какой суммы подготовить сдачу?</p>
              <div class="flex items-center gap-4">
                <div class="relative w-fit transition-opacity" >
                  <input
                    v-model="cashback"
                    type="number"
                    class="w-[15ch] rounded-xl border border-transparent bg-black bg-opacity-10 px-4 py-3 pr-8 text-end outline-none transition-colors"
                    :class="{
                      '!border-red': !!cashbackError,
                    }"
                  />
                  <span class="absolute right-4 top-1/2 -translate-y-1/2 select-none text-black text-opacity-50">
                    ₽
                  </span>
                </div>
                  <!--
                <label class="flex items-center gap-2">
                  <InputCheckbox name="no_cashback" />
                  <span class="cursor-pointer select-none"> Без сдачи </span>
                </label>
               -->
              </div>
            </div>
          </div>
        </div>
        <OrderDialogInputRadio
          class="mb-2"
          value="card"
          :disabled="!user.delivery_zone.available_payments.card || isLeaveUnderDoor"
          :label="'Картой при получении'+(!user.delivery_zone.available_payments.card ? ' (временно недоступно для выбранного ресторана)' : '')"
        >
          <IconCard />
        </OrderDialogInputRadio>
          <OrderDialogInputRadio
              class="mb-2"
              value="sbp"
              :label="'По СБП'+(!user.delivery_zone.available_payments.online ? ' (временно недоступно для выбранного ресторана)' : '')"
              :disabled="isOnlinePaymentDisabled || !user.delivery_zone.available_payments.online"
          >
              <IconSbp />
          </OrderDialogInputRadio>
        <OrderDialogInputRadio
          class="mb-2"
          value="online"
          :label="'Картой на сайте'+(!user.delivery_zone.available_payments.online ? ' (временно недоступно для выбранного ресторана)' : '')"
          :disabled="isOnlinePaymentDisabled || !user.delivery_zone.available_payments.online"
        >
          <IconCard />
        </OrderDialogInputRadio>

          <div v-if="isOnlinePaymentDisabled" class="opacity-50">
              Оплата онлайн доступна, только если заказ оформлен в день доставки
          </div>
      </HeadlessRadioGroup>

        <div class="container mx-auto" v-if="selectedPayType == 'online'">
            <div class="w-72">
                <HeadlessListbox v-model="selectedCard">
                    <div class="relative mt-1">
                        <HeadlessListboxButton
                            class="relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left shadow-md focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm"
                        >
                            <span class="block truncate">{{ selectedCard?.number }}</span>
                            <span
                                class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2"
                            >
                                <ChevronDownIcon
                                    class="h-5 w-5 text-gray-400"
                                    aria-hidden="true"
                                />
            </span>
                        </HeadlessListboxButton>

                        <transition
                            leave-active-class="transition duration-100 ease-in"
                            leave-from-class="opacity-100"
                            leave-to-class="opacity-0"
                        >
                            <HeadlessListboxOptions
                                class="absolute mt-1 max-h-60 w-full z-20 overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                            >
                                <HeadlessListboxOption
                                    v-for="card in cards"
                                    v-slot="{ active, selected }"
                                    :key="card.id"
                                    :value="card"
                                    as="template"
                                >
                                    <li
                                        :class="[
                    active ? 'bg-amber-100 text-amber-900' : 'text-gray-900',
                    'relative cursor-default select-none py-2 pl-10 pr-4',
                  ]"
                                    >
                  <span
                      :class="[
                      selected ? 'font-medium' : 'font-normal',
                      'block truncate',
                    ]"
                  >{{ card.number }}</span>
                                        <span
                                            v-if="selected"
                                            class="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600"
                                        >
                    <CheckIcon class="h-5 w-5" aria-hidden="true" />
                  </span>
                                    </li>
                                </HeadlessListboxOption>
                            </HeadlessListboxOptions>
                        </transition>
                    </div>
                </HeadlessListbox>

                <div v-if="selectedCardId == 0" class="mt-4">
                    <HeadlessSwitchGroup>
                        <div class="flex items-center">
                            <InputSwitch name="save_card"></InputSwitch>
                            <HeadlessSwitchLabel class="ml-4">Сохранить карту</HeadlessSwitchLabel>
                        </div>
                    </HeadlessSwitchGroup>
                </div>
            </div>
        </div>

      <div class="mt-8 flex w-full gap-4 font-medium">
        <button
          class="flex grow items-center justify-center rounded-xl bg-gray px-2 py-4 text-xs uppercase"
          type="button"
          @click="emit('backToCart')"
        >
          Назад в корзину
        </button>
        <SimpleButton
          class="grow p-2 sm:p-4 text-xs uppercase"
          type="submit"
          :disabled="props.isFormSubmitDisabled"
        >
          Оформить заказ
          <!--<IconArrowRight class="inline h-4" />   {{ props.basket?.total_sum }}&nbsp;&#8381; -->


            <div v-if="props.isFormSubmitDisabled"
                class="ms-2 inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-white"
                role="status">
                  <span class="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]"></span>
            </div>
        </SimpleButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useCards } from '~/composables/api/cards'

import { ChevronDownIcon, CheckIcon } from '@heroicons/vue/20/solid'
import creditCardType from 'credit-card-type'
import type { GetBasketResponse } from '~/composables/api/basket'
import { useRestaurant } from '~/composables/api/restaurants'
import { useUser } from '~/composables/api/user'

const props = defineProps<{
    isFormSubmitDisabled?: boolean
    basket?: GetBasketResponse
}>()

const emit = defineEmits(['backToCart', 'close'])

const { data: receptionWay } = useCurrentReceptionWay()

const isLeaveUnderDoor = ref(false)
const isOnlinePaymentDisabled = ref(false)
const dateChanged = (d: Date) => {
    if (d.toDateString() == (new Date()).toDateString()) {
        isOnlinePaymentDisabled.value = false
        if (selectedPayType.value == undefined) {
            updateSelectedPaymentType()
        }
    } else {
        isOnlinePaymentDisabled.value = true
        if (selectedPayType.value == 'online' || selectedPayType.value == 'sbp') {
            updateSelectedPaymentType()
        }
    }
}
const leaveUnderDoorChanged = (value: boolean) => {
    isLeaveUnderDoor.value = value
    updateSelectedPaymentType();
}

const spend = useFieldValue<number>('spend')
const paymentSum = computed(() => {
    let result = props.basket?.total_sum || 0
    if (result && spend.value > 0) {
        result -= spend.value
    }
    return result
})

const {data: user, isSuccess: isUserLoaded} = useUser((v) => v)
const userNearestRestaurantId = computed(() => user.value?.nearest_restaurant_id)
const enabled = computed(() => !!user.value?.nearest_restaurant_id)

const {data: restaurant, isSuccess: isRestaurantLoaded} = useRestaurant({restaurantId: userNearestRestaurantId, enabled: enabled, select: (v) => v})

watch(restaurant, () => {
    updateSelectedPaymentType();
})

/*
const defaultPaymentErrorText = 'временно недоступно для выбранного ресторана'
const disabledPaymentError = ref(defaultPaymentErrorText)

watch(user, () => {
    if (user.value?.delivery_zone.only_nearest_time) {
        disabledPaymentError.value = 'недоступно для выбранного адреса доставки'
    } else {
        disabledPaymentError.value = defaultPaymentErrorText
    }
}, {immediate: true})
 */

const updateSelectedPaymentType = () => {
    selectedPayType.value = undefined

    if(user.value?.delivery_zone.available_payments.cash && !isLeaveUnderDoor.value) {
        selectedPayType.value = 'cash'
        return
    }
    if(user.value?.delivery_zone.available_payments.card && !isLeaveUnderDoor.value) {
        selectedPayType.value = 'card'
        return
    }

    if(user.value?.delivery_zone.available_payments.online && !isOnlinePaymentDisabled.value) {
        selectedPayType.value = 'sbp'
        return
    }
}

const selectedCard = ref()
const { data: cards } = useCards((v) => {
    let newCard = {id: 0, number: "Новая карта", name: "Новая карта", is_selected: true},
        cards = [newCard]

    if (v.cards.length > 0) {
        cards = [...cards, ...v.cards]
        newCard.is_selected = false
    }

    selectedCard.value = cards.find(el => el.is_selected);
    return cards
})

watch(selectedCard, () => {
    selectedCardId.value = selectedCard.value.id
})

const { value: selectedPayType } = useField<string | undefined>('payment_type')
const { value: cashback, errorMessage: cashbackError } = useField<number | undefined>('need_change')
const { value: selectedCardId } = useField<any | undefined>('card_id')

const showMyLocationDialog = ref(false)
const closeMyLocationDialog = () => {
  showMyLocationDialog.value = false
}
</script>
